export default "__VITE_ASSET__Canb3059__"